
import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { Observable, from } from 'rxjs';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { SupplierRegistrationApprovalDecisionDTO, SupplierRegistrationActivationDTO, SupplierDTO } from '../models/e-tender.model';
import { HttpHeaders } from '@angular/common/http';
import { AppConfig } from './app.config';
import { saveAs } from 'file-saver';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  constructor(
    private http: HttpServices, private global: GlobalServices) {

  }
  public GetSupplierPaged(pageIndex: number, pageSize: number, language: string, SupplierTypeId: number,
     AccountStatusId: number, SupplierNumber: string,CompanyName: string,CompanyEmail: string, currentUser: string, category: number,TaxRecordNumber: string, RequestNumber: string, MobileNumber: string) {
    return this.http.get('Supplier/GetAllReport?pageIndex=' + pageIndex + '&pageSize=' + pageSize +
     '&language=' + language + '&SupplierTypeId=' + SupplierTypeId + '&AccountStatusId=' +
      AccountStatusId + '&SupplierNumber=' + SupplierNumber + '&CompanyName=' + CompanyName +'&CompanyEmail='+CompanyEmail+ '&currentUser=' + currentUser + '&catId=' + category+'&TaxRecordNumber=' + TaxRecordNumber + '&RequestNumber=' + RequestNumber + '&MobileNumber=' + MobileNumber);
  }
  GetSupplier(supplierId: string) {
    return this.http.get('Supplier/GetSupplierById?supplierId=' + supplierId);
  }

  public GetSupplierForRating(supplierId: string, language: string, currentUser: string) {
    return this.http.get('Supplier/GetSupplierByIdForRating?supplierId=' + supplierId
      + '&language=' + language + '&currentUser=' + currentUser);
  }


  public DeActivateSupplier(SupplierId) {
    return this.http.get('Supplier/DeActivateSupplier?SupplierId=' + SupplierId);
  }
  public ActivateSupplier(SupplierId) {
    return this.http.get('Supplier/ActivateSupplier?SupplierId=' + SupplierId);
  }
  public BlackListedSupplier(SupplierId) {
    return this.http.get('Supplier/BlackListedSupplier?SupplierId=' + SupplierId);
  }
  public RateSupplierSpeciality(SupplierId, ratings) {
    return this.http.post('Supplier/RateSupplierSpeciality?SupplierId=' + SupplierId, ratings);
  }
  public SubmitSupplierRegistrationPurchasingAdminDecision(purchasingAdminDecision: SupplierRegistrationApprovalDecisionDTO) {
    return this.http.post('Supplier/SubmitSupplierRegistrationPurchasingAdminDecision', purchasingAdminDecision);
  }
  public SubmitSupplierRegistrationTechnicalAdminDecision(purchasingAdminDecision: SupplierRegistrationApprovalDecisionDTO) {
    return this.http.post('Supplier/SubmitSupplierRegistrationTechnicalAdminDecision', purchasingAdminDecision);
  }
  public SubmitSupplierRegistrationActivation(supplierRegistrationActivationDTO: SupplierRegistrationActivationDTO) {

    return this.http.post('Supplier/submitSupplierRegistrationActivation', supplierRegistrationActivationDTO);
  }
  public EditSupplier(updatedSupplier: SupplierDTO) {

    return this.http.post('Supplier/EditSupplier', updatedSupplier);
  }
  public ExportSupplierExcel(supplierObject: string, language: string, AccountStatusId: number,
                             SupplierTypeId: number, SupplierNumber: string, CompanyName: string,CompanyEmail: string, currentUser: string, category: number,TaxRecordNumber: string, RequestNumber: string, MobileNumber: string) {
      this.global.isLoaderEnabled = true;
      const httpOptions = {
      responseType: 'blob' as 'json'
    };
      return this.http.http.post(AppConfig.settings.apiServer.apiUrl + 'Supplier/ExportSupplierExcel?language=' +
      language + '&AccountStatusId=' + AccountStatusId + '&SupplierTypeId=' + SupplierTypeId +
       '&SupplierNumber=' + SupplierNumber + '&CompanyName='+ CompanyName +'&CompanyEmail='+CompanyEmail+'&currentUser=' + currentUser + '&catId=' + category
       +'&TaxRecordNumber=' + TaxRecordNumber + '&RequestNumber=' + RequestNumber + '&MobileNumber=' + MobileNumber,
      { Data: supplierObject }, httpOptions).subscribe(result => {
        this.downLoadFile(result, 'application/vnd.ms-excel');
      }, () => { }, () => {
      });
  }
  downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type });
    saveAs(blob, 'ExcelReport.xlsx');
    this.global.isLoaderEnabled = false;
  }
  public CheckDuplicatedSupplierTaxRecordNumber(taxRecordNumber: string) {
    return this.http.get('Supplier/CheckDuplicatedSupplierTaxRecordNumber?taxRecordNumber=' + taxRecordNumber);
  }
  public  GetSuppliersBySpecialitiesId(oldSpecs: number[]) {
    return this.http.post('Supplier/GetSuppliersBySpecialitiesId', oldSpecs);
  }
  public test() {
    return this.http.get('Supplier/TestSendMail');
  }

  public CheckRegistrationAvailability(){
    return this.http.get("Supplier/CheckRegistrationAvailability");
  }
}
